var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsYoutube = function SvgMillustrationsYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "M34.705 16.632a1.75 1.75 0 0 0-1.235-1.235c-1.09-.295-5.47-.295-5.47-.295s-4.38 0-5.47.295a1.75 1.75 0 0 0-1.235 1.235 18 18 0 0 0-.295 3.37c-.007 1.13.092 2.258.295 3.37a1.75 1.75 0 0 0 1.235 1.235c1.09.295 5.47.295 5.47.295s4.38 0 5.47-.295a1.75 1.75 0 0 0 1.235-1.235c.204-1.112.303-2.24.295-3.37a18 18 0 0 0-.295-3.37m-8.105 5.47v-4.2l3.635 2.1z",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsYoutube;